import React, { useEffect } from 'react'

import { FieldProps } from 'formikV2'

import OptionToggle from 'components/OptionToggle'

import { FormOptions } from './form'
import { Label } from './styled-components'

type Props = {
  label: string
} & FieldProps

export const ToggleSwitch = ({ field, form, label }: Props) => {
  const handleValueChange = () => {
    form.setFieldValue(field.name, !field.value)

    if (field.name !== FormOptions.NONE_APPLY && !field.value) {
      form.setFieldValue(FormOptions.NONE_APPLY, false)
    } else if (field.name === FormOptions.NONE_APPLY && !field.value) {
      form.setFieldValue(FormOptions.AFFILIATED_BROKER, false)
      form.setFieldValue(FormOptions.BACKUP_WITHHOLDING, false)
      form.setFieldValue(FormOptions.SHAREHOLDER_DIRECTOR, false)
    }
  }

  useEffect(() => {
    if (form.isSubmitting) {
      const options = Object.values(FormOptions)
      let isAllFalse = true
      options.forEach(option => {
        if (form.values[option]) {
          isAllFalse = false
        }
      })
      if (isAllFalse) {
        form.setFieldValue(FormOptions.NONE_APPLY, true)
      }
    }
  }, [form.isSubmitting])

  return (
    <>
      <Label>{label}</Label>
      <OptionToggle icons={false} checked={field.value} onChange={handleValueChange} />
    </>
  )
}
